<template>
  <div
    :class="loaderClass"
    class="loader"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    center: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loaderClass() {
      const style = [this.size]
      if (this.center) style.push('center')
      if (this.color !== null) style.push(`col-${ this.color }`)
      if (this.inline !== null && this.inline) style.push('inline')
      return style.join(' ')
    }
  }
})
</script>

<style lang="scss" scoped>
/* import loaders */
@import "~spinthatshit/src/loaders";

.loader {
  @include loader02;
  border-radius: 100px !important;

  &.center {
    margin: 0 auto;
  }

  &.medium {
    border-width: 2px;
    width: 28px;
    height: 28px;
  }

  &.small {
    width: 19px;
    height: 19px;
    border-width: 2px;
  }

  &.inline {
    display: inline-block;
  }

  &.col-white {
    border-color: rgba(255, 255, 255, 0.34);
    border-top-color: #fff;
  }
}
</style>